import { render, staticRenderFns } from "./SalesPrintTerminals.vue?vue&type=template&id=10ee168a&scoped=true"
import script from "./SalesPrintTerminals.vue?vue&type=script&lang=js"
export * from "./SalesPrintTerminals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ee168a",
  null
  
)

export default component.exports